module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_L1-16d0029c019ced9976a285013c40fa20.png";